import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { cssClass } from '~src/style';
import { applyColor } from '~src/style/ColorService';

const cssPrefix = 'ConnectToLLMDialog';
export namespace ConnectToLLMDialogStyles {

  export const formTable = cssClass(cssPrefix, 'form-table', {
    width: '100%'
  });

  export const descriptionText = cssClass(cssPrefix, 'description-text', {
    display: 'inline'
  });

  export const descriptionContainer = cssClass(cssPrefix, 'description-container', {
    marginBottom: TabStyles.Spacing.MediumSpace
  });

  export const inputStyle = cssClass(cssPrefix, 'input-style', {
    width: '100%'
  });

  // `as const` preserves the literal type for @tableau/icons' size union.
  export const API_KEY_TOGGLE_ICON_SIZE = 14 as const;
  const API_KEY_TOGGLE_ICON_PADDING = 3;
  const API_KEY_TOGGLE_HIT_AREA = API_KEY_TOGGLE_ICON_SIZE + API_KEY_TOGGLE_ICON_PADDING * 2;
  // Anchor from the bottom so the field label doesn't shift the icon vertically.
  const API_KEY_TOGGLE_BOTTOM_OFFSET = 2;
  const API_KEY_TOGGLE_RIGHT_OFFSET = 6;
  const API_KEY_TOGGLE_RIGHT_PADDING = API_KEY_TOGGLE_HIT_AREA + API_KEY_TOGGLE_RIGHT_OFFSET + 2;

  export const apiKeyInputContainer = cssClass(cssPrefix, 'api-key-input-container', {
    position: 'relative',
    width: '100%'
  });

  export const apiKeyInputField = cssClass(cssPrefix, 'api-key-input-field', {
    width: '100%',
    $nest: {
      'input': {
        paddingRight: API_KEY_TOGGLE_RIGHT_PADDING
      }
    }
  });

  export const apiKeyVisibilityToggle = cssClass(cssPrefix, 'api-key-visibility-toggle', {
    position: 'absolute',
    right: API_KEY_TOGGLE_RIGHT_OFFSET,
    bottom: API_KEY_TOGGLE_BOTTOM_OFFSET,
    width: API_KEY_TOGGLE_HIT_AREA,
    height: API_KEY_TOGGLE_HIT_AREA,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    color: 'inherit',
    borderRadius: TabStyles.Sizing.BorderRadius,
    $nest: {
      '&:focus-visible': {
        outline: '2px solid currentColor',
        outlineOffset: '1px'
      }
    }
  });

  // --- OAuth section styles (for Custom Gateway / LLM Gateway) ---

  export const oauthSectionHeader = cssClass(cssPrefix, 'oauth-section-header', {
    marginTop: TabStyles.Spacing.LargeSpace,
    marginBottom: TabStyles.Spacing.SmallSpace,
    paddingTop: TabStyles.Spacing.SmallSpace,
  });

  export const fileSelectionContainer = cssClass(cssPrefix, 'file-container', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    width: '100%',
    height: 'auto',
    padding: '8px',
    marginTop: '4px',
    marginBottom: '8px',
    border: '2px dashed',
    position: 'relative'
  });

  export const dragAndDropChildren = cssClass(cssPrefix, 'inner-container', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    zIndex: 1,
  });

  export const textMargin = cssClass(cssPrefix, 'text-margin', {
    marginTop: '0px',
    marginBottom: '8px',
    textAlign: 'center',
  });

  export const invalidFileColor = cssClass(cssPrefix, 'invalid-color', {
    color: applyColor(DesignTokens.color.font.default.error, TabStyles.Colors.AttentionDark),
  });

  export const validFileColor = cssClass(cssPrefix, 'valid-color', {
    color: applyColor(DesignTokens.color.feedback.default.success_subtle, '#00a370'),
  });

  export const defaultFileColor = cssClass(cssPrefix, 'default-color', {
    color: applyColor(DesignTokens.color.font.inverse.default, '#ccc'),
  });

  export const spinnerStyle = cssClass(cssPrefix, 'spinner-style', {
    lineHeight: 'normal',
    padding: 5,
    display: 'inline-block'
  });

}
